module.exports = __webpack_public_path__ + "static/media/caliber.7f56e288.png";